function nextTick(cb) {
    return setTimeout(cb);
}
export default nextTick;
//# sourceMappingURL=next-tick.js.map